import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { usePathname } from 'next/navigation';
import { cn } from '@/utils/cn';
import Slider from '@/app/components/Slider';
import fetchSimilarProducts from '@/redux/thunk/similar-products-thunk';
import DynamicSectionTitle from '../Typography/DynamicSectionTitle';

function PdpSimilarProductCarousel({ section }) {
  const pathname = usePathname();
  const dispatch = useDispatch();
  const { currentParentProductDetail } = useSelector(
    (state) => state.productDetail,
  );
  const { items: categoryList } = useSelector((state) => state.categories);
  const { items } = useSelector((state) => state.similarProducts);
  const { lang: selectLang } = useSelector((state) => state.globalSettings);

  useEffect(() => {
    if (
      (currentParentProductDetail?.parent_category?.slug ||
        currentParentProductDetail?.category?.slug) &&
      currentParentProductDetail?.product?.slug
    ) {
      let categories = [currentParentProductDetail?.category?.id];
      const parentCategorySlug =
        currentParentProductDetail?.parent_category?.slug;
      const productSlug = currentParentProductDetail?.product?.slug;
      if (parentCategorySlug) {
        const parentCategoryDetails = categoryList?.find(
          (category) => category?.slug === parentCategorySlug,
        );
        categories = parentCategoryDetails?.children?.map(
          (childCategory) => childCategory.id,
        );
      }
      if (productSlug && categories) {
        dispatch(
          fetchSimilarProducts({ slug: productSlug, categoryIds: categories }),
        );
      }
    }
  }, [currentParentProductDetail, categoryList]);

  const isPDP = () => pathname.startsWith('/product/');

  return (
    <div>
      {items?.length > 0 ? (
        <section className="similar-items mb-24 lg:mb-48">
          <div
            className={cn('container mx-auto', {
              '3xl:max-w-[1440px]': !isPDP,
            })}
          >
            <DynamicSectionTitle
              text={section?.title[selectLang]}
              className={cn({
                'text-center': pathname === '/',
              })}
            />
          </div>
          <Slider type="similar-items" items={items} />
        </section>
      ) : null}
    </div>
  );
}

export default PdpSimilarProductCarousel;
